import isMobile from 'is-mobile';
import { FC } from 'react';

import { Popover, PopoverContent, PopoverTrigger, useDisclosure } from '@bonusly/design-system';

import { Bonus } from '../../../../../types/bonus';
import { useReactionMutations } from './hooks/use-reaction-mutations';
import { useSelectedReaction } from './hooks/use-selected-reaction';
import { ReactionsButton } from './reaction-button';
import { ReactionMenu } from './reaction-menu';
import { ReactionSelectContext } from './reaction-select-context';

export interface ReactionSelectProps {
	bonus: Bonus;
}

export const ReactionSelect: FC<ReactionSelectProps> = ({ bonus }) => {
	const { isOpen, onClose, onToggle } = useDisclosure();
	const selected = useSelectedReaction(bonus);
	const mutations = useReactionMutations(bonus);

	return (
		<ReactionSelectContext.Provider
			value={{
				bonus,
				selected,
				onToggle,
				...mutations,
			}}
		>
			<Popover isLazy openDelay={350} placement="top" {...(isMobile() ? { isOpen, onClose } : { trigger: 'hover' })}>
				<PopoverTrigger>
					<ReactionsButton />
				</PopoverTrigger>

				<PopoverContent borderColor="bg.subtle" boxShadow="xl" width="auto">
					<ReactionMenu />
				</PopoverContent>
			</Popover>
		</ReactionSelectContext.Provider>
	);
};
